import BranchConfigCreate from './Create'
import branchConfigEdit from './Edit'
import branchConfigList from './List'

const branchConfigResource = {
  list: branchConfigList,
  create: BranchConfigCreate,
  edit: branchConfigEdit,
}

export default branchConfigResource
